import { SUPPORTED_COUNTRIES } from '../../shared/constants'

export const getAppUrl = (inputUrl) => {
  const url = inputUrl.startsWith('/') ? inputUrl : `/${inputUrl}`
  // When we redirect to login we want to get out of the "demo"
  return url.includes('login') ? url : formatUrlInCaseOfDemo(url)
}

const formatUrlInCaseOfDemo = (url) => {
  const countryCodes = SUPPORTED_COUNTRIES.map(countryCode => countryCode.toLocaleLowerCase())

  const splitHref = window.location.href.split('/')

  const countryCode = splitHref.filter(path => countryCodes.includes(path.toLowerCase()))[0]
  const isDemo = splitHref.includes('demo')

  if (countryCode && isDemo) {
    return `/demo/${countryCode}${url}`
  }

  return url
}
